import React from 'react'
import Logo from '../../components/logo/logo'

export const LogoWithName = () => {
  return (
    <a href="/">
      <Logo style={{ height: '40px' }} />
    </a>
  )
}
